"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _featuredToutContent = _interopRequireDefault(require("../featured-tout-content"));

var _excluded = ["body", "footer", "image", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Tout body content */
  body: _propTypes.node,

  /** Tout footer content */
  footer: _propTypes.node,

  /** Tout img src url */
  image: _propTypes.string,

  /** Title content */
  title: _propTypes.node
};
/**
 * FeaturedTout2 is a generic grouping of content that includes an image,
 * title, body content, and footer. The component is a single column layout with
 * image on top of other content. An alternative component exists, [FeaturedTout]()
 * to lay out the the image to the left of other content. Root Element is [Flex]()
 * and accepts all compatible props.
 */

var FeaturedTout2 = function FeaturedTout2(_ref) {
  var body = _ref.body,
      footer = _ref.footer,
      image = _ref.image,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    flexDirection: "column",
    width: 1
  }, props), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Image, {
    mb: 2,
    src: image,
    width: 1
  }), /*#__PURE__*/_react["default"].createElement(_featuredToutContent["default"], {
    body: body,
    footer: footer,
    title: title
  }));
};

FeaturedTout2.propTypes = propTypes;
var _default = FeaturedTout2;
exports["default"] = _default;